import { Section, Eyebrow, Heading, Cta } from './home-ui';

export default function Process({ data }) {
    if (!data) return null;
    const { eyebrow, titleLine1, titleLine2, cta, steps = [] } = data;

    return (
        <Section id="process" bg="white">
            <div className="flex flex-col items-start justify-between gap-6 md:flex-row md:items-end">
                <div className="max-w-2xl">
                    {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
                    <Heading line1={titleLine1} line2={titleLine2} className="mt-4" />
                </div>
                {cta && <Cta label={cta.label} href={cta.href} />}
            </div>

            <div className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
                {steps.map((s, i) => (
                    <div key={s.step || i} className="relative rounded-card border border-surface-line bg-white p-6">
                        <div className="font-display text-sm font-bold uppercase tracking-wide text-brand">{s.step}</div>
                        <h3 className="mt-3 font-display text-lg font-bold text-navy">{s.title}</h3>
                        <p className="mt-2 text-sm leading-relaxed text-ink-muted">{s.text}</p>
                        <span className="absolute right-5 top-5 font-display text-4xl font-bold text-surface-line">{i + 1}</span>
                    </div>
                ))}
            </div>
        </Section>
    );
}
